// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2CeTH","tab":"ProcedureTabs_tab__2-U9B"};